<div class="pie-legend">
  <div
    class="legend-item"
    *ngFor="let item of dataset?.data; let i = index"
  >
    <span
      class="legend-color"
      [style.backgroundColor]="colors[i]"
    ></span>

    <span class="legend-label">
      {{ item.label }}
    </span>
  </div>
</div>
